module.exports = __webpack_public_path__ + "static/media/epark-noneOption.6b86d89b.svg";